const preferences = {
  preferenceSettings: {
    nameAlreadyExist: 'Le nom est répété !',
    nameIsEmpty: 'Le nom est vide !',
    notificationPreference: 'Sélectionnez les sites et les paramètres de préférence de notification correspondant',
    option1: 'Je souhaite recevoir des notifications de recommandation d’Enphase pour tous les sites',
    option2: 'Je souhaite personnaliser mes notifications',
    pageHeader: 'Préférences',
    title: 'Sélectionnez une option pour les Notifications',
    saveDialogHeader: 'Enregistrer les modifications ?',
    saveConfirmText: 'Souhaitez-vous enregistrer les modifications que vous avez effectuées ?',
    cancelButton: 'Ignorer',
    saveButton: 'Enregistrer',
    defaultDeselectWarning: 'Note : Vous ne pouvez pas supprimer des sites depuis Définir la préférence par défaut',
    displayPreferences: 'Afficher les préférences',
    ownSites: 'Mes sites',
    otherSites: 'Autres sites',
    emptySites: 'Aucun site disponible !',
    emptyPreferenceSet: 'Pas de préférences!',
    preference: 'Préférence',
    actions: 'Actions',
    settingsInfo: 'Ces paramètres sont applicables pour les sites Ensemble uniquement',
    selectType: 'Ensembles de préférences',
    selectSite: 'Sélection du site',
    selectSettings: 'Paramètres de préférences de notifications',
    addText: 'Ajouter',
    deleteAlertHeader: 'Confirmer la suppression',
    deleteAlertDescription: 'Êtes-vous sûrs de vouloir supprimer définitivement cette préférence ?',
    deleteAlertCancel: 'Annuler',
    deleteAlertConfirm: 'OK',
    siteEditWarning:
      'Par défaut, tous les sites possédés et les autres sites sont définis sur « Préférence par défaut – possédés » et « Préférence par défaut – autres » selon leur Préférence de notification respective.',
    defaultOwnInfo: 'Tous les sites possédés sont définis sur « Préférence par défaut – possédés »',
    defaultOtherInfo: 'Tous les autres sites sont définis sur « Préférence par défaut – autres »',
    defaultInfo: 'Tous les sites sont définis sur « Préférence par défaut »',
    createNew: 'Ajouter une nouvelle préférence',
    siteEditWarningMinimal:
      'Par défaut, les sites sont définis sur « Préférence par défaut » comme préférence de notification',
    selectAll: 'Tout sélectionner',
    generalNotification: 'Notifications générales',
    switchToNewPreferencePage: 'PASSER À LA NOUVELLES PAGE DE PRÉFÉRENCES'
  },
  preferences: {
    pageHeader: 'Préférences',
    title: 'Paramètres des préférences',
    notificationPreference: 'Préférences de notification',
    activationNotification: 'M’envoyer des notifications d’activation.',
    monthlySummary: 'M’envoyer des résumés mensuels de performance du système.',
    newsletters:
      'M’envoyer des bulletins d’informations, des promotions et des enquêtes relatifs aux produits et services Enphase.',
    newLeadsNotification: 'Me notifier en cas de nouveaux prospects et de changement de statut',
    alertEmail: 'PRÉFÉRENCES D’EMAIL D’ALERTE',
    deviceEventsEmail:
      'M’envoyer un email sur les événements au niveau de l’appareil (sélectionnez le niveau d’impact ci-dessous) :',
    exceptionsAlertEmail: 'Vous pouvez préciser des exceptions pour vos préférences d’email d’alerte par système.',
    alertPreferences: 'Voir les préférences d’alerte par système',
    saveNotificationPreferences: 'ENREGISTRER LES PRÉFÉRENCES DE NOTIFICATION',
    displayPreferences: 'Préférences d’affichage',
    displayUnits: 'Unités d’affichage',
    metric: 'Mesure',
    imperial: 'Impérial',
    saveDisplayPreferences: 'ENREGISTRER LES PRÉFÉRENCES D’AFFICHAGE',
    systemAlert: 'Préférence d’alerte du système : ',
    saveChanges: 'Enregistrer les modifications',
    label:
      'M’envoyer un email sur les événements au niveau de l’appareil (sélectionnez le niveau d’impact ci-dessous) :',
    alertEmailPreference: 'Préférence d’email d’alerte',
    systems: 'Systèmes'
  }
};

export default preferences;
